import React from "react";
import ModernPOS from './ModernPOS';

const Pos = () => {
    return <ModernPOS />;
};

export default Pos;